import React, {useState} from "react";
import {Button, Checkbox, Confirm, Header} from "semantic-ui-react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import {CustomModalHeader, S3Image} from "../custom-common";
import IMAGE from "../../constants/images";

const AutoPayOnTtile = ({strings}) => (
    <>
        <strong>{strings.autoPayIsOn}</strong><br />
        {strings.weWillNotifyYou}
    </>
);

const AutoPayOnContent = ({strings}) => {
    return (
        <div className="content">
            {strings.areYouSureYouWantToTurnOff}
        </div>
    );
};

const AutoPayOffTtile = ({strings}) => (
    <>
        <strong>{strings.setItAndForgetIt}</strong><br />
        {strings.enableAutoPayToSave}
    </>
);

const AutoPayOffContent = ({checked, onChange, strings}) => {
    return (
        <div className="content">
            <Checkbox style={{zIndex: 0}} label={strings.savePaymentMethod} onChange={onChange} checked={checked} />
            <p>
                <br />
                {strings.iAuthorizeBrellaServices}
            </p>
        </div>
    );
};

const AutoPayPreferences = ({checked, disabled, onChange, showAuthorization, strings}) => (
    <div className="content">
        <Checkbox
            style={{zIndex: 0}}
            label={strings.savePaymentMethod}
            onChange={onChange}
            checked={checked}
            disabled={disabled}
        />
        {showAuthorization && (
            <p>
                <br />
                {strings.iAuthorizeBrellaServices}
            </p>
        )}
    </div>
);

const AutoPayBox = ({strings}) => {
    const {autoPayBtn, toggleAutoPay, useGroupTypeAutoPayFlow} = PaymentDetails.useContainer();
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(useGroupTypeAutoPayFlow ? true : autoPayBtn);

    const onCancel = () => {
        if (!useGroupTypeAutoPayFlow) {
            setChecked(false);
        }
        setOpen(false);
    };

    const onConfirm = () => {
        toggleAutoPay();
        if (!useGroupTypeAutoPayFlow && !autoPayBtn) {
            setChecked(false);
        }
        setOpen(false);
    };

    const onClick = () => {
        if (useGroupTypeAutoPayFlow && !autoPayBtn) {
            setChecked(true);
            toggleAutoPay();
            return;
        }
        setOpen(true);
    };

    const onChange = (_, { checked: value }) => {
        setChecked(value);
    };

    return (
        <>
            <div>
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <div>
                        <S3Image {...IMAGE.DOLLAR}/>
                        <Header as="span" size="small">
                            <strong style={{fontSize: "16px"}}>{strings.autoPay}</strong>
                        </Header>
                    </div>
                    <Checkbox className='success'
                              style={{zIndex: 0}}
                              toggle
                              checked={autoPayBtn} onClick={onClick}
                              strings={strings}
                    />
                </div>
                <p className="neutral700Text" style={{marginTop: '1em', fontSize: '14px'}}>
                    {autoPayBtn ? <AutoPayOnTtile strings={strings} /> : <AutoPayOffTtile strings={strings} />}
                </p>
                {useGroupTypeAutoPayFlow && (
                    <AutoPayPreferences
                        checked={checked}
                        disabled={autoPayBtn}
                        onChange={onChange}
                        showAuthorization={autoPayBtn}
                        strings={strings}
                    />
                )}
            </div>
            <Confirm
                open={open}
                style={{ maxWidth: '440px'}}
                header={<CustomModalHeader title={autoPayBtn ? strings.turnOffAutoPay : strings.enableAutoPay} onClose={onCancel}/>}
                cancelButton={<Button className={"emptyButton"} content={strings.cancel} onClick={onCancel} />}
                confirmButton={<Button content={strings.confirm} disabled={!useGroupTypeAutoPayFlow && !autoPayBtn && !checked} onClick={onConfirm} />}
                size='tiny'
                content={autoPayBtn ?
                         <AutoPayOnContent strings={strings} /> :
                         (useGroupTypeAutoPayFlow ?
                             null :
                             <AutoPayOffContent strings={strings} checked={checked} onChange={onChange} />)}
            />
        </>
    );
}

export default AutoPayBox;
